export const HideIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={27} height={24} fill="none" {...props}>
    <g stroke="#707B8F" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}>
      <path d="M7.55 17.73c-2.46-1.46-4.048-3.66-4.048-5.59 0-3.28 4.566-7.3 10.202-7.3 2.305 0 4.444.67 6.165 1.71M22.361 8.61c.983 1.13 1.555 2.38 1.555 3.53 0 3.28-4.577 7.3-10.213 7.3-1.003 0-1.984-.13-2.9-.36" />
      <path d="M11.24 14.367c-.657-.59-1.024-1.392-1.02-2.23-.005-1.744 1.552-3.162 3.478-3.165.926-.002 1.815.33 2.47.925M17.133 12.7c-.258 1.291-1.373 2.304-2.798 2.541M22.407 4.25 5.01 20.024" />
    </g>
  </svg>
);
